import DatePicker from "react-datepicker";
import moment from "moment";
import Select from "react-select";
import InputRange from "react-input-range";
import HtmlId from "react-html-id";
import AsyncSelect from 'react-select/lib/Async';
var AsyncDropdown = require('./AsyncDropdown').AsyncDropdown;
var extend = require('./Helper').extend;
import { AbconetApi } from './AbconetApi';

class Checkboxlist extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        props.preValues.map((v, i) => {
            this.state[v.key] = false;
        });


        props.value.split(',').map((v) => {
            this.state[v] = true;
        });

        HtmlId.enableUniqueIds(this); 

        
    }

    onChange(key, value) {

        this.setState({ [key]: value },
            (state) => {

                var returnVar = [];
                this.props.preValues.map((v, i) => {
                    if (this.state[v.key] == true) {
                        returnVar.push(v.key);
                    }
                });

                this.props.onChange(returnVar.toString());
            });
    }

    render() {
        
        return (
            <div className="list-group-item form-group">
                {this.props.preValues.map((value, i) => {
                    var id = this.nextUniqueId();
                    return (
                        <div className="checkboxlist-item" key={i}>

                            <div className="custom-control custom-checkbox">
                                <input
                                    id={id}
                                    className="custom-control-input"
                                    onChange={(e) => this.onChange(value.key, e.target.checked)}
                                    type='checkbox'
                                    checked={this.state[value.key]}/>

                                <label className="custom-control-label" htmlFor={id}>{value.value}</label>
                            </div>
                        </div>
                    );
                })}
            </div>
        )
    }
}

const loadAddressOptions = (inputValue, callback) => {
    AbconetApi.get(`/api/address?term=${inputValue}`).then((addressList) => { 
        callback(addressList.list);
    });
};   

const loadContractManager = (inputValue,callback) => {
    AbconetApi.get(`/api/user/getContractManager`).then((contractManagerList) => { 
        callback(contractManagerList.list);
    });
}; 

export class RepeatableElement extends React.Component {
    constructor(props) {
        super();
        this.state = {
            rows: [props.config],
            data: []
        };
    }

    handleChange(index, newData) {
        console.log('hand change',
            {
                index,
                newData
            })
        var stateData = this.state.data;

        stateData[index] = newData;

        this.setState({
            data: stateData
        }, this.doOnChange);
    }

    doOnChange() {
        this.props.onChange(this.state.data);
    }

    addRow() {
        var rows = this.state.rows;
        rows.push(this.props.config);

        this.setState({ rows: rows });
    }

    renderRow(row, index) {
        return <Form className="form-repeatable" config={[row]} onChange={this.handleChange.bind(this, index)} useDiv={true} hideButtons={true} />;
    }

    render() {

        return (
            <div>
                {this.state.rows.map(this.renderRow, this)}
                
                <div onClick={this.addRow.bind(this)}>Add row</div>
            </div>
        );

    }
}


export class Form extends React.Component {
    constructor(props)
    {
        super();
        
        if (props.config != null) {
            var startingData = {};

            for (var i = 0; i < props.config.length; i++) {
                var element = props.config[i];
                startingData[element.name] = element.value;
            }

            this.state = {
                hasSubmitted: false,
                data: startingData
            }
        } 
        HtmlId.enableUniqueIds(this);   
    }

    handleDateChange(element, newValue) {
        this.handleChange(element, moment(newValue).format('YYYY-MM-DD'));
    }

    handleCheckboxChange(element, event) {
        this.handleChange(element, event.target.checked);
    }

    handleTextareaChange(element, event) {
        this.handleChange(element, event.target.value);
    }

    handleGroupChange(element, newValue) {

        console.log('data2',
            {
                element,
                newValue
            })

        if (element.flatten) {
            for (var i = 0; i < element.elements.length; i++) {
                var flattenElement = element.elements[i];
                this.handleChange(flattenElement, newValue[flattenElement.name]);
            }
        } else {
            this.handleChange(element, newValue);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps !== this.props) {
            if (this.state.data.stockGroupParentCollection === "") {
                this.state.data.stockPriceGroup = "";
            }
        }
    }

    handleChange(element, newValue) {

        if (element.options != null && (element.options.addressLookup != null || element.options.contractManagerLookup != null) && newValue != null) {  
            newValue = newValue.id;
        }
        else {
            if (Array.isArray(newValue)) {
                newValue = newValue.map(a => a[element.options.valueKey]).join(",");
            }
            else if (newValue != null && element.type == "Dropdown") {
                newValue = newValue[element.options.valueKey];
            }
        }
        var obj = this.state.data;
        obj[element.name] = newValue;
        if (newValue == null && this.state.elementName != null) {
            obj[this.state.elementName] = "";
        }
        if (element.onChange) {
            element.onChange(newValue);
        }
        this.setState({ data: obj, elementName: element.name }, this.doOnChange);    
    }

    handleSubmit(ev) {
        ev.preventDefault();

        this.setState({ hasSubmitted: true },
            () => {
                if (this.isValid()) {
                    if (this.props.onSubmit) {
                        this.props.onSubmit(this.state.data);
                    }
                }
            });
    }

    clearValue(elementName) {
        var obj = this.state.data;
        if (obj[elementName] != null) {
            obj[elementName] = null;
            this.setState({ data: obj }, this.doOnChange);
        }
    }

    clearData() {
        this.setState({ data: {}, hasSubmitted: false }, this.doOnChange);
    }

    

    doOnChange() {
        if (this.props.onChange)
        {
            this.props.onChange(this.state.data);
        }
    }


    renderComponent(element) {
        var input = null;
        var label = element.label;
        var id = this.nextUniqueId();

        if (element.visible === false) {
            return null;
        }

        switch (element.type) {
            case "Date":
                input = <DatePicker
                    selected={moment(element.value).toDate()}
                    onChange={this.handleDateChange.bind(this, element)}
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                />
                break;

            case "Dropdown":
                // We have the potential for the values of the dropdown, populated with passed in data, populated with a url, populated with a url that is searchable
                 
                var defaultOptions = { "isMulti": true, "autoBlur": true, "labelKey": "value", "valueKey": "key" };
                var options = extend(defaultOptions, element.options);

                options.getOptionLabel = (option) => option[options.labelKey];
                options.getOptionValue = (option) => option[options.valueKey];

                if (options.addressLookup) {

                    input = <AsyncSelect
                        cacheOptions
                        isClearable
                        getOptionLabel={(address) => <span>{address.name} {address.addressLine2}</span>}
                        getOptionValue={(option) => {
                            return option['id'];
                        }}
                        loadOptions={loadAddressOptions}
                        defaultOptions
                        onChange={this.handleChange.bind(this, element)} />;

                }
                else if (options.contractManagerLookup) {

                    input = <AsyncSelect
                        cacheOptions
                        isClearable
                        getOptionLabel={(contractManager) => <span>{contractManager.displayName}</span>}
                        getOptionValue={(option) => {
                            return option['id'];
                        }}
                        loadOptions={loadContractManager}
                        defaultOptions
                        onChange={this.handleChange.bind(this, element)}
                    />;

                }
                else if (options.searchUrl) {
                    input = <AsyncDropdown
                        value={this.state.data[element.name]}
                        getOptionValue={(option) => (option['value'])}
                        onChange={this.handleChange.bind(this, element)}
                        options={options}
                    />;
                } else {
                    if (Array.isArray(element.preValues)) { 
                        var value = this.state.data[element.name] + '';
                        if (value) {
                            var valueArray = [];
                            var list = value.split(',');
                            var i = 0;
                            for (i = 0; i < list.length; i++) {
                                var listItem = list[i];
                                var item = element.preValues.filter(x => x[options.valueKey] == listItem)[0];                                 
                                valueArray.push(item);
                            }
                            value = valueArray;
                        } 

                        input = <Select
                            value={value}
                            
                            onChange={this.handleChange.bind(this, element)}
                            options={element.preValues}
                            {...options}
                        />;

                    } else {
                        input = <AsyncDropdown
                            url={element.preValues}
                            value={this.state.data[element.name]}
                            onChange={this.handleChange.bind(this, element)}
                            options={options} />;
                    }

                }
                
                break;

            case "Checkbox":
                label = null;
                input = (<div className="custom-control custom-checkbox checkbox">
                            <input className="custom-control-input" id={id} type="checkbox" checked={element.value} onChange={this.handleCheckboxChange.bind(this, element)} />
                            <label className="custom-control-label" htmlFor={id}>{element.label}</label>
                         </div>);
                
                break;

            case "Checkboxlist":
                input = (<Checkboxlist
                    onChange={this.handleChange.bind(this, element)}
                    value={element.value}
                    preValues={element.preValues}
                         />);

                break;

            case "Slider":
                label = label + ": " + element.value.min + " - " + element.value.max;
                input = <InputRange
                    formatLabel={this.formatSliderLabel}
                    value={element.value}
                    onChange={this.handleChange.bind(this, element)}
                    {...element.options}
                    />;
                break;

            case "Textarea":
                input = (
                    <textarea className="form-control" value={this.state.data[element.name]} onChange={this.handleTextareaChange.bind(this, element)}></textarea>
                );
                break;

            case 'Textbox':
                input = (
                    <input type="text" className="form-control" value={this.state.data[element.name]} onChange={this.handleTextareaChange.bind(this, element)} />
                );
                break;

            case 'Group':
                return <Form key={`form-${element.name}`} className="form-row" config={element.elements} onChange={this.handleGroupChange.bind(this, element)} useDiv={true} hideButtons={true} />;

            case 'Repeat':
                return <RepeatableElement key={`form-${element.name}`} config={element.element} onChange={this.handleChange.bind(this, element)} />;


            default:
                console.error("Element " + element.type + " not registered");
        }


        return (
            <div key={`form-${element.name}`} className={`form-group input-${element.type.toLowerCase()} ${element.className}`}>
                <label>{label}</label>
                <div className="input-container">
                    {input}
                    {this.validateElement(element)}
                </div>
            </div>
        );
    }

    isValid() {

        for (var i = 0; i < this.props.config.length; i++) {
            var valid = this.validateElement(this.props.config[i]);
            if (valid != null) {
                return false;
            }
        }

        return true;
    }

    validateElement(element) {
        if (this.state.hasSubmitted) {
            if (element.required &&
                (this.state.data[element.name] == undefined || this.state.data[element.name].length === 0)) {
                return <span className="field-validation-error">The field {element.label} is required.</span>;
            }
        }
        return null;
    }

    render() {
        var buttons = (
            <div className="buttons">
                <button type="submit" className="btn btn-primary cur-p">Submit</button>
            </div>
        );

        if (this.props.hideButtons)
        {
            buttons = null;
        }

        if (this.props.config != null && this.props.config.length > 0) {
            if (this.props.useDiv) {
                return (
                    <div className={this.props.className}>
                        {this.props.config.map(this.renderComponent, this)}
                        {buttons}
                    </div>
                );
            } else {
                return (
                    <form className={this.props.className} onSubmit={this.handleSubmit.bind(this)}>
                        {this.props.config.map(this.renderComponent, this)}
                        {buttons}
                    </form>
                );
            } 
        }

        return null;
    }
}
